import Vue from 'vue'
import VueLodash from 'vue-lodash'

// const options = { name: 'lodash' } // customize the way you want to call it

Vue.use(VueLodash) // options is optional